<template>
    <div class="app__tab third_step" :class="{ disable: availableStep < 3 }">
        <div class="app__tab_title" @click="goToStep(3)">
            <span>3</span>
            <p>выбор услуги</p>
        </div>
        <transition name="fade">
            <div v-show="step === 3">
                <div class="app__tab-wrapper">
                    <div class="app__work-list">
                        <treeselect
                            :key="searchWorks"
                            multiple
                            alwaysOpen
                            flat
                            :class="{
                                search_icon_hidden: !treeselectPlaceHolder,
                            }"
                            disableBranchNodes
                            disableFuzzyMatching
                            :cacheOptions="false"
                            loadingText="Загрузка списка"
                            noResultsText="По данному запросу ничего не найдено"
                            valueFormat="object"
                            openDirection="bottom"
                            :options="fixedWorksList"
                            :placeholder="treeselectPlaceHolder"
                            v-model="selectedWorksListForBothVariants"
                            @search-change="utilSearch"
                            ref="treeselect"
                        >
                            <label slot="option-label" slot-scope="{ node }">
                                <p>{{ node.label }}</p>
                                <span>{{
                                    node.raw.workPrice
                                        ? node.raw.workPrice.toFixed(1) +
                                          " руб."
                                        : ""
                                }}</span>
                            </label>
                        </treeselect>
                        <button class="clearSearch" v-show="searchInput.length" @click="checkSearch"><span></span><span></span></button>
                    </div>
                    <FormApiCart
                        @goToStep="goToStep"
                        :assets_url="assets_url"
                    ></FormApiCart>
                </div>
                <button class="btn" @click="goToStep(2)">Назад</button>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
    name: "WorksSelection",
    props: {
        assets_url: { type: String },
        API_URL: { type: String },
        rate: { type: Number },
        step: { type: Number },
        availableStep: { type: Number },
    },
    data: () => ({
        workList: [],
        fixedWorksList: [],
        selectedList: [],
        searchWorks: 1,
        treeselectPlaceHolder: "Выберите услугу",
        searchInput: ''
    }),
    mounted() {
        if (this.selectedEngine) {
            this.getWorksFromApi();
        }
        // if (this.selectedWorks.length && this.xlsxWorks.length) {
        //     this.selectedList = this.selectedWorks.concat(
        //         this.selectedXlsxWorks
        //     );
        // }
    },
    methods: {
        checkSearch(){
            this.$refs.treeselect.trigger.searchQuery = "";
            this.utilSearch("")
        },
        utilSearch(text) {
            this.treeselectPlaceHolder = text ? "" : "Выберите услугу";
            this.searchInput = text
        },

        /**
         * Отправка запроса на получение списка работ по API
         */
        getWorksFromApi() {
            this.$emit("loader");

            fetch(
                `${this.API_URL}normTreeList?engineId=${this.selectedEngineId}`,
                {
                    headers: {
                        Authorization:
                            "Bearer e09421f76fc24dbbbfdcf0adb9a87c5a",
                    },
                }
            )
                .then((response) => {
                    this.selectedList = this.fixedWorksList = [];
                    this.searchWorks += 1;
                    this.treeselectPlaceHolder = "Выберите услугу";
                    return response.json();
                })
                .then((response) => {
                    this.workList = response;
                    this.fixedWorksList = response
                        .filter((item) => item.parentId === null)
                        .map((item) => {
                            return {
                                id: item.id,
                                label: item.detailName,
                                children: this.recursionOptions(item.id),
                                workPrice: null,
                            };
                        });

                    this.fixedWorksList = this.fixedWorksList.concat(
                        this.xlsxWorks
                    );
                })
                .then(() => {
                    this.$emit("loader");
                });
        },

        /**
         * Сброс списка работ
         */
        resetWorks() {
            this.$store
                .dispatch("updateStateValue", {
                    target: "apiWorks",
                    value: [],
                })
                .then(() => {
                    this.workList = [];
                });
        },
        /**
         *
         */
        recursionOptions(id) {
            let _ = this.workList.filter((item) => item.parentId === id);
            return _.length
                ? _.map((item) => {
                      let response = {
                              id: item.id,
                              label: item.detailName,
                              workPrice: item.workTime * this.rate,
                          },
                          _ = this.recursionOptions(item.id);

                      if (_.length) {
                          response.children = _;
                      }

                      return response;
                  })
                : [];
        },
        goToStep(step) {
            this.$emit("goToStep", step);
        },
    },
    computed: {
        selectedEngineId() {
            return this.selectedEngine ? this.selectedEngine.id : null;
        },
        selectedEngine() {
            return this.$store.getters["getValue"]("engine");
        },
        selectedWorks() {
            return this.$store.getters["getValue"]("apiWorks");
        },
        xlsxWorks() {
            return this.$store.getters["getValue"]("exlsWorks");
        },
        selectedXlsxWorks() {
            return this.$store.getters["getValue"]("selectedExlsWorks");
        },
        selectedWorksListForBothVariants: {
            set(value) {
                let apiWorks = [],
                    xlsxWorks = [];

                value.filter((item, key) => {
                    if (Number(item.id)) {
                        apiWorks.push(item);
                    } else {
                        xlsxWorks.push(item);
                    }
                });

                this.$store.dispatch("setWorks", {
                    api: apiWorks,
                    xlsx: xlsxWorks,
                });
            },
            get() {
                return this.$store.getters.getBothSelectedWorks;
            },
        },
    },
};
</script>
<style lang="scss" scoped>
    .clearSearch{
        position: absolute;
        right: 16px;
        top: 35px;
        width: 10px;
        height: 10px;
        transform: translate(-50%, -50%);
        outline: none;
        border: none;
        background: transparent;
        span{
            position: absolute;
            top: 50%;
            left: 0;
            width: 100%;
            height: 1px;
            background: #585858;
            pointer-events: none;
            &:nth-of-type(1) {
                transform: rotate(45deg);
            }
            &:nth-of-type(2) {
                transform: rotate(-45deg);
            }
        }
    }
</style>